import { Entity } from "../api/entities/entityApi";

/**
 * Helper function to get entity name by ID
 */
export const createGetEntityNameById = (entities: Entity[]) => {
    return (entityIds: string[]) => {
        return entityIds.map(entityId => {
            const entity = entities.find((e: Entity) => e.id === entityId);
            return entity?.abbreviatedName;
        });
    };
};

/**
 * Helper function to get badge color for transaction categories
 */
export const getCategoryBadgeColor = (category: string): string => {
    const lowerCategory = category?.toLowerCase() || "";
    if (lowerCategory.includes("goods") || lowerCategory.includes("manufacturing") || lowerCategory.includes("distribution")) {
        return "blue";
    } else if (lowerCategory.includes("services") || lowerCategory.includes("support") || lowerCategory.includes("management")) {
        return "green";
    } else if (lowerCategory.includes("ip") || lowerCategory.includes("intellectual") || lowerCategory.includes("technology")) {
        return "pink";
    }
    return "gray";
};

/**
 * Helper function to get badge color for methods
 */
export const getMethodBadgeColor = (method: string): string => {
    const lowerMethod = method?.toLowerCase() || "";
    if (lowerMethod.includes("cup") || lowerMethod.includes("cut") || lowerMethod.includes("cusp")) {
        return "orange";
    } else if (lowerMethod.includes("margin") || lowerMethod.includes("resale")) {
        return "teal";
    } else if (lowerMethod.includes("cost") || lowerMethod.includes("plus")) {
        return "red";
    } else if (lowerMethod.includes("profit") || lowerMethod.includes("split")) {
        return "yellow";
    }
    return "gray";
};
